import { abstractHooks } from '@datadog/browser-core';
export const createHooks = (abstractHooks);
